// Runtime-safe backend URL resolver.
// Always prefers same-origin (empty prefix → relative path) in browsers.
// Falls back to REACT_APP_BACKEND_URL only in non-browser environments (tests/SSR).
// This prevents login/CORS failures when the JS bundle is baked with a wrong
// REACT_APP_BACKEND_URL at build time (e.g. pointing to preview while the app
// is served from production domain).
const resolve = () => {
  try {
    if (typeof window !== 'undefined' && window.location && window.location.origin) {
      return '';
    }
  } catch (e) {
    // ignore
  }
  return process.env.REACT_APP_BACKEND_URL || '';
};

export const BACKEND_BASE = resolve();
export default BACKEND_BASE;
